import { useStorage as useStorageVueUse } from '@vueuse/core'
import type { PiniaPluginContext } from 'pinia'
import type { CheckoutPaymentModelV2 } from '@/models/checkout-payment-model-v2'

export const paymentPiniaPlugin = async (context: PiniaPluginContext) => {
  if (process.client && context.store.$id === 'payment') {
    const DEFAULT_PAYMENT: CheckoutPaymentModelV2 = {
      address: null,
      isIdenticalToDeliveryAddress: false,
      method: null,
    }
    const paymentLocalStorage = useStorageVueUse<CheckoutPaymentModelV2>('payment-storage', DEFAULT_PAYMENT)
    if (paymentLocalStorage.value && paymentLocalStorage.value.method)
      context.store.$state.paymentData = paymentLocalStorage.value

    context.store.$subscribe(() => paymentLocalStorage.value = context.store.$state.paymentData)
  }
}
